<template>
  <v-app>
    <div class="alert__container" :style="{ minHeight: `${alertContainerHeight}px` }">
      <div ref="alert" class="alert__wrapper" :style="{ maxHeight: `${alertContainerHeight}px` }">
        <v-alert class="alert" type="warning" :icon="false">
          <div class="alert__content">
            <p>{{ $t(`systemMessages.myGuardianDocSubscriptionWarning${account?.dependent ? 'Dep' : ''}`) }}</p>
            <v-btn
              v-if="!account?.dependent"
              color="primary"
              large
              class="alert__button"
              depressed
              @click="goToSubscriptions">
              {{ $t('buttons.buyASubscription') }}
            </v-btn>
          </div>
        </v-alert>
      </div>
    </div>
    <div class="content">
      <l-header v-if="showHeader" :vertical-offset="alertContainerHeight" />
      <l-sidebar v-if="showSideBar" />
      <v-main :key="$i18n.locale">
        <!-- <re-captcha /> -->
        <router-view :key="$route.name" />
      </v-main>
    </div>
    <L-dialog />
    <l-loading />
    <l-notifications />
    <mini-chat />
    <mobile-app-banner />
  </v-app>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';

import LLoading from '@/components/layouts/LLoading';
import LNotifications from '@/components/layouts/LNotifications';
// import ReCaptcha from '@/components/shared/ReCaptcha';
import MobileAppBanner from '@/components/shared/MobileAppBanner';
import externalServicesMixin from '@/common/mixins/externalServicesMixin';

import LHeader from './components/layouts/LHeader';
import LDialog from './components/layouts/LDialog';
import LSidebar from './components/layouts/LSidebar';
import MiniChat from './components/shared/MiniChat';

export default {
  components: {
    LHeader,
    LDialog,
    LSidebar,
    MiniChat,
    LLoading,
    // ReCaptcha,
    LNotifications,
    MobileAppBanner,
  },
  data() {
    return {
      user: null,
      isMounted: false,
    };
  },
  mixins: [externalServicesMixin],
  watch: {
    appPrimaryColor(val) {
      this.setPrimaryColor(val);
    },
    appSecondaryColor(val) {
      this.setSecondaryColor(val);
    },
  },
  computed: {
    ...mapState('common', ['appLoading', 'hideToolbar', 'hideSidebar', 'whiteLabel']),
    ...mapState('loggedAccount', ['account']),
    appPrimaryColor() {
      return this.whiteLabel?.primaryColor;
    },
    appSecondaryColor() {
      return this.whiteLabel?.secondaryColor;
    },
    showSideBar() {
      return !this.hideSidebar && !this.appLoading;
    },
    showHeader() {
      return !this.hideToolbar && !this.appLoading;
    },
    alertContainerHeight() {
      if (!this.isMounted || this.myGuardianDocAllowance) return 0;
      return this.$refs.alert?.scrollHeight || 0;
    },
    myGuardianDocAllowance() {
      return this.checkSubscriptionForMyGuardianDocMain(false);
    },
  },
  created() {
    window.appap = this;
    window.addEventListener('beforeunload', this.beforeUnload);
    Vue.prototype.$initAffiliateProgram();
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    beforeUnload(e) {
      e.preventDefault();
      if (sessionStorage.getItem('isLoggedIn')) this.$clearTabSession();
    },
    setPrimaryColor(color) {
      if (color) {
        document.body.style.setProperty('--primary', color);
        this.$vuetify.theme.themes.light.primary = color;
      }
    },
    setSecondaryColor(color) {
      if (color) {
        document.body.style.setProperty('--secondary', color);
        this.$vuetify.theme.themes.light.secondary = color;
      }
    },
    goToSubscriptions() {
      this.$router.push('/profile/subscriptions');
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  position: relative;
  display: flex;
  flex: 1 0 auto;
  max-width: 100%;
}

.alert {
  width: 100%;
  position: relative;
  margin: 0;

  &__container {
    position: relative;
  }

  &__wrapper {
    position: fixed;
    overflow: hidden;
    max-height: 0px;
    top: 0;
    right: 0;
    left: 280px;
    z-index: 5;
  }

  &__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

@media screen and (max-width: $screen-md) {
  .alert {
    &__wrapper {
      left: 0;
    }
  }
}
</style>
